import { render, staticRenderFns } from "./managementDetails.vue?vue&type=template&id=744e2b8e&scoped=true"
import script from "./managementDetails.vue?vue&type=script&lang=js"
export * from "./managementDetails.vue?vue&type=script&lang=js"
import style0 from "./managementDetails.vue?vue&type=style&index=0&id=744e2b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744e2b8e",
  null
  
)

export default component.exports